<div class="dropdown-wrapper" [class.open]="isOpen" tabindex="0" (click)="toggleDropdown()" (keydown.enter)="toggleDropdown()">
  <div class="dropdown-toggle" aria-haspopup="true">
    <icon icon="user-cog" scale="1"></icon>
    <icon icon="chevron-down" scale="0.5"></icon>
  </div>
  @if (isOpen) {
    <div class="dropdown-menu">
      <ul>
        <li (click)="logout()" (keydown.enter)="logout()" tabindex="0">
          <icon icon="sign-out" scale="1"></icon>
          Log Out
        </li>
      </ul>
    </div>
  }
</div>
